import React from "react";
import "./PGASweatToolPage.css";
import PGAModelBuilderSection from "../PGAModelBuilderPage/PGAModelBuilderSection";
import PGASweatsSummarySection from "./PGASweatsSummarySection";
import Tabs from "../../../../Tabs";
import FlexBreak from "../../../../FlexBreak";
import Top500ListDisplay from "./Top500ListDisplay";
import MyEntriesDisplay from "./MyEntriesDisplay";
import ContestPlayerListDisplay from "./ContestPlayerListDisplay";
import SelectDKContest from "./SelectDKContest";

export default function PGASweatToolPage() {
  const [selectedContestID, setSelectedContestID] = React.useState(undefined);

  return (
    <div className="pga-model-builder-page-container">
      <h1>PGA Sweats</h1>
      <div className="pga-model-builder-container">
        <PGAModelBuilderSection widthType={"large"}>
          <React.Suspense fallback={"Loading events..."}>
            <div className="pga-sweat-tool-contest-select">
              <br />
              <SelectDKContest setSelectedContestID={setSelectedContestID} />
            </div>
          </React.Suspense>
        </PGAModelBuilderSection>
        {selectedContestID ? (
          <>
            <PGAModelBuilderSection widthType={"large"}>
              <React.Suspense fallback={"Loading data..."}>
                <PGASweatsSummarySection
                  contestId={selectedContestID}
                  style={{ justifyContent: "center" }}
                />
              </React.Suspense>
            </PGAModelBuilderSection>
            <br />
            <PGAModelBuilderSection
              widthType={"large"}
              style={{ justifyContent: "center" }}
            >
              <FlexBreak />
              <Tabs style={{ width: "100%" }}>
                <React.Suspense label="Top 500" fallback={"Loading data..."}>
                  <Top500ListDisplay contestId={selectedContestID} />
                </React.Suspense>
                <React.Suspense label="My Entries" fallback={"Loading data..."}>
                  <MyEntriesDisplay contestId={selectedContestID} />
                </React.Suspense>
                <React.Suspense label="Players" fallback={"Loading data..."}>
                  <ContestPlayerListDisplay contestId={selectedContestID} />
                </React.Suspense>
              </Tabs>
            </PGAModelBuilderSection>
          </>
        ) : null}
      </div>
    </div>
  );
}
